import BaseAPI from './BaseAPI';
import User from '../models/User';

export class UserAPI extends BaseAPI {

	async acknowledgeUserMessage(messageId) {
		return this.requestPlain(`/-/user/acknowledgeMessage/${messageId}`, 'POST'); 
	}

	async updateIdpAccessToken(idpAccessToken) {
		return this.request('/-/login/sso', 'PUT', { idpAccessToken });
	}
	async changeAppType(device) {
		return this.request('/-/user/app/change', 'PUT', {
			deviceId: device.id
		});
	}
	async sendAppWelcomeMail(email) {
		return this.request('/-/user/app/welcome', 'POST', { email });
	}
	async sendWelcomeMail(email) {
		return this.request('/-/user/welcome', 'POST', { email });
	}
	async getSubscribedComponents() {
		return this.request(`/-/subscriptions/components`, 'GET');
	}
	async saveSubscriptions(subscriptions) {
		return this.request(`/-/subscriptions/components`, 'PUT', subscriptions);
	}
	
	async checkUserEmailForAccount(email) {
		return this.request(`/-/account/trial/email/${email || '-'}`, 'GET');
	}

	async is2FAEnabled() {
		return this.request('/-/account/2FA', 'GET');
	}
	async set2FAEnabled(enabled: boolean) {
		return this.request('/-/account/2FA', 'PUT', { enabled });
	}
	async resetTwoFA(user) {
		return this.request('/-/account/2FA/reset', 'PUT', { user });
	}

	async agreedToTermsOfUse() {
		return this.request('/-/user/terms', 'PUT');
	}
	async agreedToPrivacy() {
		return this.request('/-/user/privacy', 'PUT');
	}

	async saveLanguage(language: string) {
		return this.request('/-/user/lang', 'PUT', {language});
	}

	async getUsers(force) : User[] {
		const res = await this.request(`/-/user?force=${force ? 1 : 0}`, 'GET');
		return res.map(u => new User(u));
	}

	async deleteUsers(users, informUser) {
		return await this.request(`/-/user`, 'DELETE', {
			userIds: users.map(u => u.id),
			informUser: !!informUser
		});
	}

	async updateUser(user, inviteForApp, appType) {
		return this.request('/-/user', 'PUT', {
			id: user.id,
			email: user.get('email'),
			groupId: user.get('groupId'),
			language: user.get('language'),
			inviteForApp: !!inviteForApp,
			advancedApp: appType === 'advanced'
		});
	}

	async addUser(user, informUser, inviteForApp, appType) {
		return this.request('/-/user', 'POST', {
			email: user.get('email'),
			groupId: user.get('groupId'),
			language: user.get('language'),
			informUser: !!informUser,
			inviteForApp: !!inviteForApp,
			advancedApp: appType === 'advanced'
		});
	}

	sendModuleActivationRequest(moduleId, comment) {
		return this.request('/-/module/request', 'POST', {moduleId, comment});
	}

	async getAppSeats() {
		return this.request('/-/user/app', 'GET');
	}
	async connectApp(user, inviteForApp) {
		return this.request('/-/user/app', 'PUT', {
			id: user.id,
			informUser: !!inviteForApp
		});
	}

	async getPttSeats() {
		return this.request('/-/user/ptt', 'GET');
	}
	async togglePtt(user) {
		return this.request('/-/user/ptt', 'PUT', {
			id: user.id
		});
	}

	async processSubscription(optIn) {
		return this.request('/-/user/notifications', 'PUT', {
			notification: 'newsletterNL',
			enabled: optIn
		});
	}
	async resetMyTwoFA(email, password) {
		return this.request('/+/user/resetMyTwoFA', 'POST', { email, password });
	}
	async requestSecurityCode(email, password) {
		return this.request('/+/user/twoFaCode', 'POST', { email, password });
	}
}
